<template>
  <div class="result">
    <label class="result__heading">{{
      $t("project_details.style_quiz.investor_quiz_group")
    }}</label>
    <article v-for="result in styleQuizResults">
      <div class="user">
        <div class="user__info">
          <UserImage
            :src="result.user.imagePath"
            :user="result.user"
            alt="Zdjęcie użytkownika"
          />
          <div class="user__name">
            <h2>{{ result.user.name }}</h2>
            <span v-if="result.user.projectRole === Role.Client">{{
              $t("profile.role.client")
            }}</span>
            <span v-else-if="result.user.projectRole === Role.Admin">{{
              $t("profile.role.admin")
            }}</span>
            <span v-else-if="result.user.projectRole === Role.Architect">{{
              $t("profile.role.architect")
            }}</span>
            <span v-else>{{ $t("profile.role.client") }}</span>
          </div>
        </div>
        <button
          v-if="
            projectInfo.myRoleInProject === Role.Client && result.user.id === auth.user.id
          "
          @click="emit('onRestart')"
          class="user__button"
        >
          <svg
            width="6"
            height="10"
            viewBox="0 0 6 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="fill"
          >
            <path
              d="M-2.03986e-07 4.66667L4.85735 -4.9947e-08L6 1.09142L2.28531 4.66667L6 8.24191L4.85734 9.33333L-2.03986e-07 4.66667Z"
            />
          </svg>

          {{ $t("project_details.style_quiz.do_it_again") }}
        </button>
        <div
          class="user__button-group"
          v-if="
            (projectInfo.myRoleInProject === Role.Architect ||
              auth.user.role === Role.Admin) &&
            (!result.styles || result.styles?.length === 0)
          "
        >
          <button
            @click="copyLink"
            class="user__button user__button-secondary tooltip-wrapper"
            :title="$t('project_details.style_quiz.copy_link')"
          >
            <div class="tooltip">
              {{ $t("project_details.style_quiz.copy_link") }}
            </div>
            <svg
              width="15"
              height="17"
              viewBox="0 0 15 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="fill"
            >
              <path
                d="M13.1364 13.9091H4.63636C4.21136 13.9091 3.84767 13.7579 3.54527 13.4555C3.24236 13.1526 3.09091 12.7886 3.09091 12.3636V1.54545C3.09091 1.12045 3.24236 0.7565 3.54527 0.453591C3.84767 0.151197 4.21136 0 4.63636 0H9.40796C9.61402 0 9.81055 0.0386363 9.99755 0.115909C10.184 0.193182 10.3481 0.302652 10.4898 0.444318L14.2375 4.19205C14.3792 4.33371 14.4886 4.49779 14.5659 4.68427C14.6432 4.87127 14.6818 5.0678 14.6818 5.27386V12.3636C14.6818 12.7886 14.5306 13.1526 14.2282 13.4555C13.9253 13.7579 13.5614 13.9091 13.1364 13.9091ZM9.27273 1.54545H4.63636V12.3636H13.1364V5.40909H10.0455C9.82652 5.40909 9.64312 5.33517 9.49527 5.18732C9.34691 5.03895 9.27273 4.8553 9.27273 4.63636V1.54545ZM1.54545 17C1.12045 17 0.756758 16.8488 0.454364 16.5464C0.151455 16.2435 0 15.8795 0 15.4545V5.40909C0 5.19015 0.0741819 5.0065 0.222546 4.85814C0.370394 4.71029 0.553788 4.63636 0.772727 4.63636C0.991667 4.63636 1.17532 4.71029 1.32368 4.85814C1.47153 5.0065 1.54545 5.19015 1.54545 5.40909V15.4545H9.27273C9.49167 15.4545 9.67532 15.5287 9.82368 15.6771C9.97153 15.8249 10.0455 16.0083 10.0455 16.2273C10.0455 16.4462 9.97153 16.6296 9.82368 16.7775C9.67532 16.9258 9.49167 17 9.27273 17H1.54545ZM4.63636 1.54545V5.40909V1.54545V12.3636V1.54545Z"
              />
            </svg>
            {{ fullPathUrl.slice(0, 15) }}...
          </button>
          <button
            :class="{
              user__button: true,
              'user__button-disabled': isInvitationSent(result.user.email),
            }"
            :disabled="isInvitationSent(result.user.email)"
            @click="sendInvitation(result.user)"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="stroke"
            >
              <path
                d="M6.59429 9.40571L15 1M15 1L10.033 14.7548C9.99946 14.828 9.94563 14.89 9.8779 14.9334C9.81017 14.9769 9.73139 15 9.65091 15C9.57043 15 9.49165 14.9769 9.42392 14.9334C9.35619 14.89 9.30236 14.828 9.26883 14.7548L6.59429 9.40571L1.2452 6.73117C1.17203 6.69764 1.11004 6.64381 1.06657 6.57608C1.02311 6.50835 1 6.42957 1 6.34909C1 6.26861 1.02311 6.18983 1.06657 6.1221C1.11004 6.05437 1.17203 6.00054 1.2452 5.96701L15 1Z"
                stroke-width="1.2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            {{
              isInvitationSent(result.user.email)
                ? "Zaproszenie wysłane"
                : "Wyślij zaproszenie"
            }}
          </button>
        </div>
      </div>
      <div class="style-container">
        <div class="style" v-for="style in result?.styles" :key="style.name">
          <div class="style__info">
            <PercentageCircle
              v-if="style.value < 1"
              :percent="style.value * 100"
            />
            <div>
              <h2 class="style__title">{{ style.name }}</h2>
              <div class="style__tags">
                <div class="style__tag" v-for="tag in style.tags">
                  {{ tag }}
                </div>
              </div>
            </div>
          </div>
          <div class="style__images">
            <img class="style__image" v-for="img in style.images" :src="img" />
          </div>
          <div class="style__desc">
            <p
              v-if="Array.isArray(style.description)"
              v-for="d in style.description"
            >
              {{ d }}
            </p>
            <p v-else>
              {{ style.description }}
            </p>
          </div>
        </div>
      </div>
    </article>
    <div class="user add-investor" v-if="projectInfo.myRoleInProject === Role.Architect">
      <button class="add-investor__button" @click="showAddMemberToProjectModal">
        <svg
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="14" cy="14" r="13.5" fill="#498388" stroke="#498388" />
          <path d="M21 15H15V21H13V15H7V13H13V7H15V13H21V15Z" fill="white" />
        </svg>

        {{ $t("projects.add.add_investor") }}
      </button>
    </div>
  </div>
  <AddMemberToProjectModal
    ref="addMemberToProjectModal"
    :role="Role.Client"
    @addMember="onAddMember"
  />
</template>

<script setup>
import PercentageCircle from "@/components/PercentageCircle/PercentageCircle.vue";
import { useAuthStore } from "@/stores/auth.store";
import { computed, ref, inject } from "vue";
import { Role } from "@/helpsers/role.helper";
import UserImage from "@/components/image/UserImage.vue";
import { useI18n } from "vue-i18n";
import AlertHelper from "@/helpsers/alert.helper";
import AddMemberToProjectModal from "@/components/architect/projectSettings/AddMemberToProjectModal";
import authHelper from "@/helpsers/auth.helper";
import ApiHelper from "@/helpsers/api.helper";
import axios from "axios";

const addMemberToProjectModal = ref("");

function showAddMemberToProjectModal() {
  console.log("click");
  addMemberToProjectModal.value.showModal();
}
const emitter = inject("emitter");
function onAddMember() {
  emitter.emit("updateProjectDetails");
}

const emit = defineEmits(["onRestart"]);
const props = defineProps(["projectInfo"]);

const auth = useAuthStore();

const mapMemberIntoUser = (member) => {
  return {
    imagePath: member?.imagePath,
    name: [member?.firstName, member?.lastName].join(" "),
    firstName: member.firstName,
    lastName: member.lastName,
    role: member?.role,
    projectRole: member?.projectRole,
    id: member?.id,
    email: member?.email,
  };
};

const styleQuizResults = computed(() => {
  const hasResults =
    props.projectInfo.styleQuizResults &&
    props.projectInfo.styleQuizResults?.length > 0;
  if (!hasResults) {
    const clientMembersOnly = props.projectInfo.members
      .filter((member) => member.projectRole === Role.Client)
      .map((member) => ({
        user: mapMemberIntoUser(member),
        styles: undefined,
      }));
    return clientMembersOnly;
  }
  if (props.projectInfo.myRoleInProject === Role.Client) {
    // put user's result on the top of the screen
    const myResult = props.projectInfo.styleQuizResults.find(
      (result) => result.user.id === auth.user.id
    );
    const restResults = props.projectInfo.styleQuizResults.filter(
      (result) => result.user.id !== auth.user.id
    );
    if (myResult) {
      restResults.unshift(myResult);
    }
    return restResults;
  }

  const clientsWhoHaveDoneTheQuiz = props.projectInfo.styleQuizResults.map(
    (result) => result.user.id
  );
  const clientsWhoHaveNotDoneTheQuiz = props.projectInfo.members
    .filter((member) => member.projectRole === Role.Client)
    .filter((member) => {
      return !clientsWhoHaveDoneTheQuiz.includes(member.id);
    })
    .map((member) => ({
      user: mapMemberIntoUser(member),
      styles: undefined,
    }));
  return [
    ...props.projectInfo.styleQuizResults,
    ...clientsWhoHaveNotDoneTheQuiz,
  ];
});

const { t } = useI18n();
const alert = inject("alert");

const invitationsSent = ref({});

function isInvitationSent(email) {
  return invitationsSent.value[email];
}

function sendInvitation(user) {
  axios
    .post(
      ApiHelper.getResendInviteToProjectUrl(props.projectInfo?.id),
      {
        email: user.email,
      },
      {
        headers: authHelper.authHeader(),
      }
    )
    .then((result) => {
      invitationsSent.value[user.email] = true;
      AlertHelper.show(
        alert,
        t("project_details.style_quiz.success_send_email_title"),
        t("project_details.style_quiz.success_send_email_desc"),
        "success"
      );
    })
    .catch((error) => {
      const errorMessage = ApiHelper.getResponseMessage(
        error.response?.data?.code
      );
      AlertHelper.show(alert, errorMessage, "", "error");
    });
}
const fullPathUrl = ref(window.location.href);

function copyLink() {
  navigator.clipboard.writeText(fullPathUrl.value).then(
    function () {
      AlertHelper.show(alert, t("project_details.style_quiz.copied"));
    },
    function (err) {
      console.error("Async: Could not copy text: ", err);
    }
  );
}
</script>

<style scoped lang="scss">
.result {
  &__heading {
    font-weight: 500;
    font-size: 1.75rem;
    line-height: 1.2;

    color: #767a80;
  }
  article {
    margin-bottom: 4rem;
  }
}

.user {
  position: relative;
  width: 100%;
  background-color: #f5f5f5;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 24px 10px 10px;
  margin: 16px 0 0 0;
  border-radius: 10px;
  &__info {
    display: flex;
    align-items: center;
    gap: 15px;
  }
  &__name {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    gap: 4px;
  }
  h2 {
    font-weight: 600;
    font-size: 1.875rem;
    line-height: 1.2;
    letter-spacing: 0.025em;
  }
  span {
    font-size: 1.5rem;
    line-height: 1.2;
    letter-spacing: 0.035em;
    color: #8c8f94;
  }
  &__button-group {
    display: flex;
    align-items: center;
    gap: 2rem;
  }
  &__button {
    height: 32px;
    padding: 0 2rem;
    background: rgba(142, 79, 79, 0.1);
    border: 1px solid rgba(142, 79, 79, 0.2);
    border-radius: 6px;
    display: flex;
    align-items: center;

    font-family: "Montserrat";
    font-weight: 500;
    font-size: 1.5rem;
    line-height: 1.2;
    color: #8e4f4f;
    transition: 300ms;
    &:hover:enabled {
      cursor: pointer;
      background-color: #8e4f4f;
      color: white;
      svg.fill {
        path {
          fill: #fff;
        }
      }
      svg.stroke {
        path {
          stroke: #fff;
        }
      }
    }
    svg {
      margin-right: 8px;
    }
    svg.fill {
      path {
        fill: #8e4f4f;
      }
    }
    svg.stroke {
      path {
        stroke: #8e4f4f;
      }
    }
    &-secondary {
      background-color: transparent;
      border: 1px solid #e6e6e6;
      color: #8c8f94;
      max-width: 160px;

      &:hover:enabled {
        border: 1px solid #35353566;
        color: #353535;
        background-color: transparent;
        svg.fill {
          path {
            fill: #353535;
          }
        }
      }
      svg.fill {
        path {
          fill: #999ba0;
        }
      }
    }
    &-disabled {
      opacity: 0.6;
    }
  }
}

.style-container {
  display: flex;
  flex-direction: column;
  gap: 36px;
}
.style {
  &:first-child {
    margin-top: 16px;
  }
  &:only-child {
    margin-top: 0;
  }
  &__info {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  &__title {
    font-weight: 600;
    font-size: 2.75rem;
    line-height: 1.2;
    color: #3b767b;
    margin: 8px 0;
  }
  &__tags {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }
  &__tag {
    font-weight: 500;
    font-size: 1.5rem;
    line-height: 2.3;
    display: flex;
    align-items: center;
    text-align: center;
    padding: 0 10px;
    background: #edf3f4;
    border-radius: 4px;
    color: #498388;
  }
  &__images {
    display: grid;
    margin: 25px 0;
    gap: 20px;

    grid-template-columns: 1fr;
    @media (min-width: 700px) {
      grid-template-columns: 1fr 1fr;
    }
    @media (min-width: 1300px) {
      grid-template-columns: 1fr 1fr 1fr;
    }
  }
  &__image {
    width: 100%;
    aspect-ratio: 1.5;
    background: #ffffff;
    border: 1px solid #e6ebeb;
    border-radius: 10px;
    gap: 25px;
  }
  &__desc {
    display: flex;
    gap: 2rem;
    font-size: 1.875;
    line-height: 1.5;
    text-align: justify;
    p {
      width: 100%;
      max-width: 500px;
    }
    @media (max-width: 1700px) {
      justify-content: space-between;
    }
    @media (max-width: 700px) {
      flex-direction: column;
    }
  }
}
.add-investor {
  background-color: #eef4f4;
  padding: 2rem 2rem;
  &__button {
    background-color: transparent;
    border: none;
    cursor: pointer;
    font-size: 2.25rem;
    font-weight: 500;
    color: #498388;
    opacity: 0.8;
    transition: 350ms;
    display: flex;
    align-items: center;
    gap: 14px;
    &:hover {
      opacity: 1;
    }
  }
}
.tooltip-wrapper {
  position: relative;
  &:hover {
    .tooltip {
      visibility: visible;
    }
  }
}
.tooltip {
  position: absolute;
  visibility: hidden;
  font-weight: 500;
  font-size: 1.5rem;
  line-height: 2.3;
  top: calc((-1) * (1.5rem * 2.3 + 15px));
  left: 0;
  right: 0;
  background: #ffffff;
  border: 1px solid #ededed;
  border-radius: 4px;
  margin: auto;
  width: fit-content;
  height: fit-content;
  padding: 0 2rem;
}
</style>
